<div class="container">

    <div class="row mb-2">
        <div class="col-md-12">
            <h4 class="text-primary mb-4">{{ data.TITLE }}</h4>
            <p>{{ data.SUB_TITLE }}</p>
            <p>{{ data.DESCRICAO }}</p>
        </div>
    </div>

    <div class="row d-flex justify-content-center">

        <div *ngFor="let info of data.IMAGENS; let lastItem = last; let index = index"
            class="col-12 col-sm-8 col-lg-2 d-flex align-items-stretch">

            <div class="card w-100 mb-2" [ngClass]="{'imagem-selecionada': imagemSelecionada == info.CODIGO}"
                (click)="selecionaImagem(info.CODIGO)">

                <div class="card-header bg-primary text-white text-center">
                    <span>{{info.TITLE}}</span>
                </div>

                <div class="card-body text-center p-0">
                    <img class="img-fluid h-100 w-100" src="{{url}}{{info.IMAGEM}}">
                </div>

            </div>

        </div>

    </div>

</div>